import React from 'react';
import * as autoOverviewStyle from '../../styles/internal-page/autoOverview.module.scss';
import { useTranslation } from 'react-i18next';
import Anchor from '../shared/Anchor';
import PropTypes from 'prop-types';
import {normalizeString} from '../../utils/utils';

const AutoOverview = ({ blocs }) => {
  const {t} = useTranslation();

  blocs = blocs.filter(e => {
    if (e['bloc_type'] && e['bloc_type'] === 'TEXT') {
      return false;
    }
    return true;
  });

  const getBlocType = (bloc) => {
    if (bloc['bloc_type']) {
      return `${bloc['__typename']}-${bloc['bloc_type']}`;
    }
    return bloc['__typename'];
  };

  return (
    <div className={autoOverviewStyle.root}>
      <h2>
        {t('product.page.overview')}
      </h2>
      <ul>
        {blocs.map((bloc, index) => (
          <li key={index + 'anchor_overview'}>
            <Anchor
              anchor={normalizeString(t(`product.anchor.${getBlocType(bloc, index)}`))
                .replace(/ /g, '_').toLowerCase()}
              className={autoOverviewStyle.anchor}
              title={t(`product.anchor.${getBlocType(bloc, index)}`)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

AutoOverview.propTypes = {
  blocs: PropTypes.arrayOf(PropTypes.shape({
    bloc_type: PropTypes.string,
    __typename: PropTypes.string.isRequired,
  })).isRequired,
};

export default AutoOverview;